<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="bk-title">Peter Pan</p>
<p class="authorname">J. M. Barrie</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2title_page.vue?168910a8